import { IClientComponentDefinition } from '@glidecms/deliver-core-dev/gd-module'

export const VerticalLatestNewsCCD: IClientComponentDefinition = {
  name: 'verticalLatestNews',
  load: () => import(/* webpackChunkName: 'verticalLatestNews' */ './index'),
}
